<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="working">
					<app-heading title="Working Events">
						<template slot="right">
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="events"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								@update="fetchEvents"
							>
								<template v-slot:data="{ item }">
									<app-json :data="item.data" />
								</template>
								<template v-slot:actions="{ item }">
									<app-button-confirm
										v-if="$ravello.can('system.post')"
										color="warning"
										icon="fa-ban"
										table
										label-confirm="Fail"
										:description="`Are you sure you want to force the failure of the event`
											+`<b>${item.id}</b>?`"
										title="Fail Event"
										@click="onFail(item.id)"
									>
										Fail
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { eventsTabs } from '@/datasources/tabs'

export default {
	data() {
		return {
			events: [],
			tabs: eventsTabs,
			count: -1,
			refresh: false,
			headers: [{
				text: 'ID',
				value: 'id',
				sortable: false,
			}, {
				text: 'Event',
				value: 'name',
				sortable: false,
			}, {
				text: 'Data',
				value: 'data',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				width: '20%',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchEvents(pagination) {
			const request = this.$ravello.request()
				.to('system')
				.to('events')
				.to('working')
				.fromPagination(pagination)

			try {
				this.events = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onFail(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('system')
					.to('events')
					.to('working')
					.to(id)
					.to('fail')
					.create()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
